import React from "react";
import { Helmet } from "react-helmet";
import DashboardLayout from "@/components/DashboardLayout";
import HeroSection from "@/components/about/HeroSection";
import TeamSection from "@/components/about/TeamSection";
import MissionSection from "@/components/about/MissionSection";
import CareersSection from "@/components/about/CareersSection";
import EventsSection from "@/components/about/EventsSection";
import BackersSection from "@/components/about/BackersSection";
import AboutCTA from "@/components/about/AboutCTA";
import PageCallToAction from "@/components/PageCallToAction";

const About = () => {
  return (
    <DashboardLayout>
      <Helmet>
        <title>About Us | OpenPipe</title>
        <meta
          name="description"
          content="Building enterprise-grade AI solutions with advanced RL and fine-tuning"
        />
      </Helmet>
      <div className="max-w-6xl mx-auto space-y-16">
        <div>
          <h1 className="text-4xl font-bold tracking-tight font-mono">
            About OpenPipe
          </h1>
          <p className="text-muted-foreground mt-2">
            Building enterprise-grade AI solutions with advanced RL and
            fine-tuning
          </p>
        </div>
        <MissionSection />
        <BackersSection />
        <EventsSection />
        <PageCallToAction />
      </div>
    </DashboardLayout>
  );
};

export default About;
